import { UberDirectActionType } from './uberDirectActionType';

export const setUberDirectApiError: (errorMsg) => any =
  (errorMsg) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_UBER_DIRECT_API_ERROR,
      payload: errorMsg,
    });
  };

export const setDeliveryPhoneError: (data) => any =
  (data) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_DELIVERY_PHONE_ERROR,
      payload: data,
    });
  };

export const setDeliveryNameError: (name) => any =
  (name) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_DELIVERY_NAME_ERROR,
      payload: name,
    });
  };

export const setSelectCity: (city) => any = (city) => async (dispatch) => {
  dispatch({
    type: UberDirectActionType.SET_SELECTED_CITY,
    payload: city,
  });
};

export const setSelectArea: (area) => any = (area) => async (dispatch) => {
  dispatch({
    type: UberDirectActionType.SET_SELECTED_AREA,
    payload: area,
  });
};

export const setSelectStreet: (street) => any =
  (street) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_SELECTED_STREET,
      payload: street,
    });
  };

export const setStructuredAddress: (address) => any =
  (address) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_STRUCTURED_ADDRESS,
      payload: address,
    });
  };

export const setDelivrableAction: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_DELIVERABLE_ACTION,
      payload: boolVal,
    });
  };

export const setWA10Member: (memberCdoe) => any =
  (memberCdoe) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_WA10_MEMBER,
      payload: memberCdoe,
    });
  };

export const setUberDirectDeliveryType: (boolVal) => any =
  (boolVal) => async (dispatch) => {
    dispatch({
      type: UberDirectActionType.SET_DELIVERY_TYPE,
      payload: boolVal,
    });
  };
